import * as types from '../actions/action-types';

// Individual Projects

export function getProjectsSuccess(projectData) {
  return {
    type: types.GET_PROJECTS_SUCCESS,
    projectData
  };
}

export function propsRecievedProjectPage(propsRecieved) {
  return {
    type: types.PROPS_RECIEVED_PROJECT_PAGE,
    propsRecieved
  };
}

// Projects in Category

export function getProjectsInCategorySuccess(projectsInCategoryData) {
  return {
    type: types.GET_PROJECTSINCATEGORY_SUCCESS,
    projectsInCategoryData
  };
}

export function propsRecievedProjectsInCategory(propsRecieved) {
  return {
    type: types.PROPS_RECIEVED_PROJECTSINCATEGORY,
    propsRecieved
  };
}

export function projectNameInCategory(name) {
  return {
    type: types.PROJECT_NAME_IN_CATEGORY,
    name
  };
}


/** WEBPACK FOOTER **
 ** ./src/js/actions/project-actions.js
 **/